<template>
  <modal :modal-key="'resubscribe-game'" :class-style="'modal modal--welcomeback'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_resubscribe_confirmation_you_are_not_subscribed }}</h1>
      <!--h2>$#Your points: <span class="points">XXX</span></h2>
      <h2>$#Your level: <span class="level">Y</span></h2-->
      <img :src="getTranslations.project_config_modal_img" alt="">
    </template>
    <template slot="body">
      {{ getTranslations.home_modals_resubscribe_confirmation_in_order_to_unlock }}
    </template>
    <template slot="footer" v-if="!existThisPathInForbiddenPages('/resubscribeSteps')">
      <a style="cursor:pointer">
        <div class="btn2 btn2--std btn2--small" @click.prevent="reOptin">
          {{ getTranslations.home_modals_resubscribe_confirmation_resubscribe }}
        </div>
      </a>
      <span class="terms">
          {{ getTranslations.home_modals_resubscribe_confirmation_by_clicking }}
          <br>
          <a style="cursor:pointer"
             :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')"
             target="_blank">{{ getTranslations.home_modals_resubscribe_confirmation_t_and_cs }}</a>
          {{ getTranslations.home_modals_resubscribe_confirmation_of_the_service }}
        </span>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import loading from '@/components/home/modals/shared/Loading';
import WelcomeReturningUnsub from './WelcomeReturningUnsub';
import ResubscribeViaPin from './ResubscribeViaPin';
import ResubscribeError from './ConfirmPurchaseForPinError';

export default {
  // modal_unsubscribe_newgame_store.html
  name: 'resubscribe-game',
  components: {
    Modal,
    loading,
  },
  data() {
    return {
      showedModal: false,
    };
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForSettings',
      'storeModalForStore',
      'storeModalForHomePage',
    ]),
    ...mapActions('common', [
      'reOptinProcess',
    ]),
    showResubModal(modal) {
      if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
        this.storeModalForStore(modal);
      } else {
        this.storeModalForHomePage(modal);
      }
    },
    reSubCallback(response) {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        this.getUserLoginDetails().then(() => {
          const hasAsyncNotification = this.getIntegrationConfig.config && this.getIntegrationConfig.config.asyncNotificationForReoptinOneStep;
          if (hasAsyncNotification) {
            this.storeWhichModal(loading);
            this.hasErrors = false;
            this.$axios.get(`api/getStatusVerificationPin?msisdn=${this.userDetails.msisdn}`).then((res) => {
              const resp = res.data.responseEnum;
              if (resp === 'OPERATION_SUCCESS') {
                this.storeWhichModal(null);
                this.showResubModal(WelcomeReturningUnsub);
              } else {
                this.storeWhichModal(null);
                this.showResubModal(ResubscribeError);
              }
            });
          } else if (this.reoptinOnestep) {
            if (this.userDetails.subscribed) {
              this.showResubModal(WelcomeReturningUnsub);
            } else {
              this.showResubModal(ResubscribeError);
            }
          } else {
            // eslint-disable-next-line
            if (!this.userDetails.subscribed) {
              this.showResubModal(ResubscribeViaPin);
            } else {
              this.showResubModal(ResubscribeError);
            }
          }
        });
      } else {
        this.showResubModal(ResubscribeError);
      }
    },
    storeWhichModal(modal) {
      if (sessionStorage.getItem('homeCurrentTabPath') === '/home' || sessionStorage.getItem('homeCurrentTabPath') === '/home/profile') {
        this.storeModalForHomePage(modal);
      } else if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
        this.storeModalForStore(modal);
      } else {
        this.storeModalForSettings(modal);
      }
    },
    reOptin() {
      sessionStorage.setItem('operator', this.userDetails.operatorName);
      this.getAppropriateReSubAction();
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'reoptinOnestep',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
    ...mapGetters('common', [
      'existThisPathInForbiddenPages',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeGame.vue